/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BucketComponentModificationResponse } from '@coin/shared/core/util-models-v2';
import { BucketComponentsPossibilities } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModel } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModificationResponse } from '@coin/shared/core/util-models-v2';
import { CalculateManySimulations } from '@coin/shared/core/util-models-v2';
import { CalculateSimulation } from '@coin/shared/core/util-models-v2';
import { CandidatePoolModel } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { CreateBucketComponent } from '@coin/shared/core/util-models-v2';
import { CreateCandidatePool } from '@coin/shared/core/util-models-v2';
import { CreateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { CreateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { CreateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { CreateMember } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { CreatePlan } from '@coin/shared/core/util-models-v2';
import { CreatePlanSettings } from '@coin/shared/core/util-models-v2';
import { CreatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { CreateSeason } from '@coin/shared/core/util-models-v2';
import { CreateSpecialPaymentGlobalHrbpApproverRule } from '@coin/shared/core/util-models-v2';
import { DuplicateSeason } from '@coin/shared/core/util-models-v2';
import { EmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { EmployeeSeasonOverview } from '@coin/shared/core/util-models-v2';
import { EmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { ExportEmployeePopulationResultDto } from '@coin/shared/core/util-models-v2';
import { MemberModel } from '@coin/shared/core/util-models-v2';
import { MeritCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { MeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models-v2';
import { OrganisationInformationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotTreeItem } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfMember } from '@coin/shared/core/util-models-v2';
import { PageOfMeritInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfPlan } from '@coin/shared/core/util-models-v2';
import { PageOfPlanWithMissingIndividualValues } from '@coin/shared/core/util-models-v2';
import { PageOfPositionEvaluationCandidate } from '@coin/shared/core/util-models-v2';
import { PageOfRecord } from '@coin/shared/core/util-models-v2';
import { PageOfSeason } from '@coin/shared/core/util-models-v2';
import { PageOfSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfSpecialPaymentGlobalHrbpApproverRule } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PlanModel } from '@coin/shared/core/util-models-v2';
import { PlanSettingsModel } from '@coin/shared/core/util-models-v2';
import { PopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { PositionEvaluationSimulationModel } from '@coin/shared/core/util-models-v2';
import { PublicationSettingsModel } from '@coin/shared/core/util-models-v2';
import { RecordModel } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SeasonModel } from '@coin/shared/core/util-models-v2';
import { SeasonSettingsModel } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsCreateSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsUpdateSimulation } from '@coin/shared/core/util-models-v2';
import { SetSeasonSettings } from '@coin/shared/core/util-models-v2';
import { SimulationPublicationsPublishSimulation } from '@coin/shared/core/util-models-v2';
import { Snapshot } from '@coin/shared/core/util-models-v2';
import { SpecialPaymentGlobalHrbpApproverRule } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models-v2';
import { UnPublishSimulation } from '@coin/shared/core/util-models-v2';
import { UpdateBucketComponent } from '@coin/shared/core/util-models-v2';
import { UpdateBudgetBucket } from '@coin/shared/core/util-models-v2';
import { UpdateCandidatePool } from '@coin/shared/core/util-models-v2';
import { UpdateCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshotPartial } from '@coin/shared/core/util-models-v2';
import { UpdateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { UpdateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { UpdateManyBudgetBuckets } from '@coin/shared/core/util-models-v2';
import { UpdateMember } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdatePlan } from '@coin/shared/core/util-models-v2';
import { UpdatePlanSettings } from '@coin/shared/core/util-models-v2';
import { UpdatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateSeason } from '@coin/shared/core/util-models-v2';
import { UpdateSimulationMembers } from '@coin/shared/core/util-models-v2';
import { UpdateSnapshotBenchmarkValues } from '@coin/shared/core/util-models-v2';
import { UpdateSpecialPaymentGlobalHrbpApproverRule } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateSpecialPaymentGlobalHrbpApproverRulesParams {
  seasonId: string;
  createSpecialPaymentGlobalHrbpApproverRule?: CreateSpecialPaymentGlobalHrbpApproverRule;
}

export interface DeleteSpecialPaymentGlobalHrbpApproverRulesParams {
  seasonId: string;
  id: string;
}

export interface QuerySpecialPaymentGlobalHrbpApproverRulesParams {
  seasonId: string;
  page?: number;
  size?: number;
}

export interface ReorderSpecialPaymentGlobalHrbpApproverRulesParams {
  seasonId: string;
  requestBody?: Array<string>;
}

export interface SeasonsSpecialPaymentAdminCalculateManySimulationParams {
  seasonId: string;
  calculateManySimulations?: CalculateManySimulations;
}

export interface SeasonsSpecialPaymentAdminCalculateSimulationParams {
  seasonId: string;
  calculateSimulation?: CalculateSimulation;
}

export interface SeasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsSpecialPaymentAdminChangePrioritiesPlansParams {
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsSpecialPaymentAdminCreateBudgetComponentsParams {
  budgetBucketId: string;
  createBucketComponent?: CreateBucketComponent;
}

export interface SeasonsSpecialPaymentAdminCreateCandidatePoolsParams {
  createCandidatePool?: CreateCandidatePool;
}

export interface SeasonsSpecialPaymentAdminCreateEmployeeSnapshotsParams {
  createEmployeeSnapshot?: CreateEmployeeSnapshot;
}

export interface SeasonsSpecialPaymentAdminCreateInformationVisibilitySettingsParams {
  simulationId: string;
  createInformationVisibilitySettings?: CreateInformationVisibilitySettings;
}

export interface SeasonsSpecialPaymentAdminCreateManyBudgetComponentsParams {
  budgetBucketId: string;
  createManyBucketComponents?: CreateManyBucketComponents;
}

export interface SeasonsSpecialPaymentAdminCreateMembersParams {
  createMember?: CreateMember;
}

export interface SeasonsSpecialPaymentAdminCreateOrganisationInformationSnapshotsParams {
  seasonId: string;
  createOrganisationInformationSnapshot?: CreateOrganisationInformationSnapshot;
}

export interface SeasonsSpecialPaymentAdminCreatePlanSettingsParams {
  planId: string;
  createPlanSettings?: CreatePlanSettings;
}

export interface SeasonsSpecialPaymentAdminCreatePlansParams {
  createPlan?: CreatePlan;
}

export interface SeasonsSpecialPaymentAdminCreatePublicationSettingsParams {
  seasonId: string;
  createPublicationSettings?: CreatePublicationSettings;
}

export interface SeasonsSpecialPaymentAdminCreateSeasonsParams {
  createSeason?: CreateSeason;
}

export interface SeasonsSpecialPaymentAdminCreateSimulationParams {
  seasonsSimulationsCreateSimulation?: SeasonsSimulationsCreateSimulation;
}

export interface SeasonsSpecialPaymentAdminDeleteBudgetComponentsParams {
  budgetBucketId: string;
}

export interface SeasonsSpecialPaymentAdminDeleteCandidatePoolsParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminDeleteEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsSpecialPaymentAdminDeleteMembersParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminDeletePlanSettingsParams {
  id: string;
  planId: string;
}

export interface SeasonsSpecialPaymentAdminDeletePlansParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminDeleteSeasonsParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminDeleteSimulationSettingsParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminDuplicateSeasonsParams {
  id: string;
  duplicateSeason?: DuplicateSeason;
}

export interface SeasonsSpecialPaymentAdminExportEmployeeCandidatesParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsSpecialPaymentAdminExportOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  fileName?: string;
}

export interface SeasonsSpecialPaymentAdminExportPlanWithMissingIndividualValuesParams {
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminExportSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetBudgetBucketsParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetBudgetBucketsPlansParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetByIdRecordsParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsSpecialPaymentAdminGetEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: Array<string>;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminGetMembersParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetMySeasonRecordsSeasonsParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsSpecialPaymentAdminGetOfSeasonPublicationSettingsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetOrganisationSnapshotsParams {
  seasonId: string;
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetPlanPopulationPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminGetPlanRecordsPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminGetPlanSettingsParams {
  planId: string;
}

export interface SeasonsSpecialPaymentAdminGetPlansParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetPublicationSettingsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetRecordsParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsSpecialPaymentAdminGetSeasonCommunicationSettingsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembersParams {
  gid?: string;
}

export interface SeasonsSpecialPaymentAdminGetSeasonRecordsSeasonsParams {
  id: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryTemplateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminGetSeasonSettingsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminGetSeasonsParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminGetSimulationParams {
  simulationId: string;
}

export interface SeasonsSpecialPaymentAdminGetSnapshotSeasonsParams {
  id: string;
  employeeId: string;
}

export interface SeasonsSpecialPaymentAdminGetTreeOrganisationSnapshotsParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshotsParams {
  snapshotId: string;
  updateEmployeeSnapshotPartial?: UpdateEmployeeSnapshotPartial;
}

export interface SeasonsSpecialPaymentAdminPrePublishSimulationPublicationsParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsSpecialPaymentAdminPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsSpecialPaymentAdminQueryCandidatePoolsParams {
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminQueryEmployeeCandidatesParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsSpecialPaymentAdminQueryEmployeeSnapshotsParams {
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidatesParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminQueryFieldValuesRecordsParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsSpecialPaymentAdminQueryInformationVisibilitySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminQueryMembersParams {
  page?: number;
  size?: number;
}

export interface SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: Array<string>;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsSpecialPaymentAdminQueryParentsOrganisationSnapshotsParams {
  seasonId: string;
  seasonId2: string;
  queryOrgCode?: string;
}

export interface SeasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValuesParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsSpecialPaymentAdminQueryPlansParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsSpecialPaymentAdminQuerySeasonsParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsSpecialPaymentAdminQuerySimulationParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminRecalculatePlanPopulationsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsSpecialPaymentAdminSavePlanPopulationsParams {
  id: string;
}

export interface SeasonsSpecialPaymentAdminSaveSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsSpecialPaymentAdminSimulatePlanPopulationsParams {
  id: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsSpecialPaymentAdminSimulateSeasonPopulationsParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  ruleSet?: RuleSet;
}

export interface SeasonsSpecialPaymentAdminUnPrePublishSimulationPublicationsParams {
  simulationId: string;
}

export interface SeasonsSpecialPaymentAdminUnPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  unPublishSimulation?: UnPublishSimulation;
}

export interface SeasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshotsParams {
  updateSnapshotBenchmarkValues?: UpdateSnapshotBenchmarkValues;
}

export interface SeasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponentsParams {
  budgetBucketId: string;
  updateManyBucketComponents?: UpdateManyBucketComponents;
}

export interface SeasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponentsParams {
  budgetBucketId: string;
  updateBucketComponent?: UpdateBucketComponent;
}

export interface SeasonsSpecialPaymentAdminUpdateBudgetBucketsParams {
  id: string;
  updateBudgetBucket?: UpdateBudgetBucket;
}

export interface SeasonsSpecialPaymentAdminUpdateCandidatePoolsParams {
  id: string;
  updateCandidatePool?: UpdateCandidatePool;
}

export interface SeasonsSpecialPaymentAdminUpdateEmployeeSnapshotsParams {
  updateEmployeeSnapshot?: UpdateEmployeeSnapshot;
}

export interface SeasonsSpecialPaymentAdminUpdateInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  updateInformationVisibilitySettings?: UpdateInformationVisibilitySettings;
}

export interface SeasonsSpecialPaymentAdminUpdateManyBudgetBucketsParams {
  updateManyBudgetBuckets?: UpdateManyBudgetBuckets;
}

export interface SeasonsSpecialPaymentAdminUpdateMembersParams {
  updateMember?: UpdateMember;
}

export interface SeasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshotsParams {
  seasonId: string;
  id: string;
  updateOrganisationInformationSnapshot?: UpdateOrganisationInformationSnapshot;
}

export interface SeasonsSpecialPaymentAdminUpdatePlanSettingsParams {
  id: string;
  planId: string;
  updatePlanSettings?: UpdatePlanSettings;
}

export interface SeasonsSpecialPaymentAdminUpdatePlansParams {
  id: string;
  updatePlan?: UpdatePlan;
}

export interface SeasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettingsParams {
  seasonId: string;
  updatePublicationSettings?: UpdatePublicationSettings;
}

export interface SeasonsSpecialPaymentAdminUpdateSeasonCommunicationSettingsParams {
  seasonId: string;
  updateCommunicationSettings?: UpdateCommunicationSettings;
}

export interface SeasonsSpecialPaymentAdminUpdateSeasonSettingsParams {
  setSeasonSettings?: SetSeasonSettings;
}

export interface SeasonsSpecialPaymentAdminUpdateSeasonsParams {
  updateSeason?: UpdateSeason;
}

export interface SeasonsSpecialPaymentAdminUpdateSimulationParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulation?: SeasonsSimulationsUpdateSimulation;
}

export interface SeasonsSpecialPaymentAdminUpdateSimulationMembersSimulationParams {
  seasonId: string;
  simulationId: string;
  updateSimulationMembers?: UpdateSimulationMembers;
}

export interface UpdateSpecialPaymentGlobalHrbpApproverRulesParams {
  seasonId: string;
  id: string;
  updateSpecialPaymentGlobalHrbpApproverRule?: UpdateSpecialPaymentGlobalHrbpApproverRule;
}

@Injectable({
  providedIn: 'root'
})
export class SeasonsSpecialPaymentAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: CreateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SpecialPaymentGlobalHrbpApproverRule>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: CreateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SpecialPaymentGlobalHrbpApproverRule>>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: CreateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SpecialPaymentGlobalHrbpApproverRule>>;
  public createSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: CreateSpecialPaymentGlobalHrbpApproverRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('createSpecialPaymentGlobalHrbpApproverRules', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSpecialPaymentGlobalHrbpApproverRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: DeleteSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: DeleteSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: DeleteSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public deleteSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: DeleteSpecialPaymentGlobalHrbpApproverRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('deleteSpecialPaymentGlobalHrbpApproverRules', { seasonId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: QuerySpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSpecialPaymentGlobalHrbpApproverRule>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: QuerySpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSpecialPaymentGlobalHrbpApproverRule>>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: QuerySpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSpecialPaymentGlobalHrbpApproverRule>>;
  public querySpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: QuerySpecialPaymentGlobalHrbpApproverRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('querySpecialPaymentGlobalHrbpApproverRules', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: ReorderSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: ReorderSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: ReorderSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public reorderSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: ReorderSpecialPaymentGlobalHrbpApproverRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('reorderSpecialPaymentGlobalHrbpApproverRules', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/priorities`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.requestBody,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCalculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateManySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCalculationStatus>;
  public seasonsSpecialPaymentAdminCalculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateManySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public seasonsSpecialPaymentAdminCalculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateManySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public seasonsSpecialPaymentAdminCalculateManySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateManySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminCalculateManySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateManySimulations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCalculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public seasonsSpecialPaymentAdminCalculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsSpecialPaymentAdminCalculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsSpecialPaymentAdminCalculateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCalculateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminCalculateSimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public seasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public seasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public seasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminChangePrioritiesInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminChangePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminChangePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminChangePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminChangePrioritiesPlans(
    requestParameters?: SeasonsSpecialPaymentAdminChangePrioritiesPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/plans/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsSpecialPaymentAdminCreateBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminCreateBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminCreateBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsSpecialPaymentAdminCreateBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminCreateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsSpecialPaymentAdminCreateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminCreateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsSpecialPaymentAdminCreateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminCreateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsSpecialPaymentAdminCreateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminCreateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsSpecialPaymentAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsSpecialPaymentAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsSpecialPaymentAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsSpecialPaymentAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminCreateInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateManyBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsSpecialPaymentAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateManyBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateManyBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminCreateManyBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsSpecialPaymentAdminCreateManyBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminCreateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsSpecialPaymentAdminCreateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminCreateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsSpecialPaymentAdminCreateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminCreateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsSpecialPaymentAdminCreateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminCreateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsSpecialPaymentAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminCreateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminCreateOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsSpecialPaymentAdminCreatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminCreatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminCreatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsSpecialPaymentAdminCreatePlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsSpecialPaymentAdminCreatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsSpecialPaymentAdminCreatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsSpecialPaymentAdminCreatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreatePublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsSpecialPaymentAdminCreatePublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminCreatePublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminCreatePublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminCreatePublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminCreatePublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsSpecialPaymentAdminCreateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsSpecialPaymentAdminCreateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsSpecialPaymentAdminCreateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminCreateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsSpecialPaymentAdminCreateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsSpecialPaymentAdminCreateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsSpecialPaymentAdminCreateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminCreateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsCreateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteMembers(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteMembers', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public seasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public seasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public seasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeletePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsSpecialPaymentAdminDeletePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeletePlans(
    requestParameters?: SeasonsSpecialPaymentAdminDeletePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminDeletePlans', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteSeasons', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDeleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsSpecialPaymentAdminDeleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsSpecialPaymentAdminDeleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsSpecialPaymentAdminDeleteSimulationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminDeleteSimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminDeleteSimulationSettings', { id, seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminDuplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDuplicateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public seasonsSpecialPaymentAdminDuplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDuplicateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsSpecialPaymentAdminDuplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDuplicateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsSpecialPaymentAdminDuplicateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminDuplicateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminDuplicateSeasons', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.duplicateSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminExportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminExportEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsSpecialPaymentAdminExportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminExportEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminExportEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminExportEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminExportEmployeeCandidates', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/employee-candidates/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        SeasonId: seasonId,
        RecordIds: requestParameters?.recordIds,
        State: requestParameters?.state,
        Filename: requestParameters?.filename
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsSpecialPaymentAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminExportOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminExportOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        fileName: requestParameters?.fileName
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsSpecialPaymentAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsSpecialPaymentAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminExportPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminExportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminExportSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExportEmployeePopulationResultDto>;
  public seasonsSpecialPaymentAdminExportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminExportSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExportEmployeePopulationResultDto>>;
  public seasonsSpecialPaymentAdminExportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminExportSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExportEmployeePopulationResultDto>>;
  public seasonsSpecialPaymentAdminExportSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminExportSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminExportSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModel>;
  public seasonsSpecialPaymentAdminGetBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModel>>;
  public seasonsSpecialPaymentAdminGetBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModel>>;
  public seasonsSpecialPaymentAdminGetBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BudgetBucketModel>>;
  public seasonsSpecialPaymentAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BudgetBucketModel>>>;
  public seasonsSpecialPaymentAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BudgetBucketModel>>>;
  public seasonsSpecialPaymentAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetBudgetBucketsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetBudgetBucketsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetByIdRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RecordModel>;
  public seasonsSpecialPaymentAdminGetByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetByIdRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RecordModel>>;
  public seasonsSpecialPaymentAdminGetByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetByIdRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RecordModel>>;
  public seasonsSpecialPaymentAdminGetByIdRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetByIdRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    this.checkRequired('seasonsSpecialPaymentAdminGetByIdRecords', { recordId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsSpecialPaymentAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsSpecialPaymentAdminGetEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetInformationFieldValuesOrganisationInformationSnapshots', {
      seasonId
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsSpecialPaymentAdminGetMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsSpecialPaymentAdminGetMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsSpecialPaymentAdminGetMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetMembers', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsSpecialPaymentAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetMySeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetMySeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { memberId: requestParameters?.memberId, gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsSpecialPaymentAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetOfSeasonPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetOfSeasonPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsSpecialPaymentAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsSpecialPaymentAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsSpecialPaymentAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsSpecialPaymentAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetOrganisationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanPopulationPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsSpecialPaymentAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanPopulationPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsSpecialPaymentAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanPopulationPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsSpecialPaymentAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanPopulationPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetPlanPopulationPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanRecordsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsSpecialPaymentAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanRecordsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanRecordsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanRecordsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetPlanRecordsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsSpecialPaymentAdminGetPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminGetPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminGetPlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsSpecialPaymentAdminGetPlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsSpecialPaymentAdminGetPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsSpecialPaymentAdminGetPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsSpecialPaymentAdminGetPlans(
    requestParameters?: SeasonsSpecialPaymentAdminGetPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsSpecialPaymentAdminGetPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminGetPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminGetPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetPublicationSettings', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsSpecialPaymentAdminGetRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetRecords(
    requestParameters?: SeasonsSpecialPaymentAdminGetRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsSpecialPaymentAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsSpecialPaymentAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsSpecialPaymentAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSeasonOverview>;
  public seasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSeasonOverview>>;
  public seasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSeasonOverview>>;
  public seasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonOverviewForEmployeeMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/members/overview`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsSpecialPaymentAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsSpecialPaymentAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetSeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.State': requestParameters?.queryState,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.TemplateType': requestParameters?.queryTemplateType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.MeasurementDate': requestParameters?.queryMeasurementDate,
        'Query.MeritTitle': requestParameters?.queryMeritTitle,
        'Query.EquityTitle': requestParameters?.queryEquityTitle,
        'Query.EquitySubTitle': requestParameters?.queryEquitySubTitle,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.LineManagerFirstName': requestParameters?.queryLineManagerFirstName,
        'Query.LineManagerLastName': requestParameters?.queryLineManagerLastName,
        'Query.CompanyManagerFirstName': requestParameters?.queryCompanyManagerFirstName,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CompanyManagerLastName': requestParameters?.queryCompanyManagerLastName,
        'Query.TemplateName': requestParameters?.queryTemplateName,
        'Query.WorkflowType': requestParameters?.queryWorkflowType,
        'Query.AutoApprove': requestParameters?.queryAutoApprove,
        'Query.ApprovalRequired': requestParameters?.queryApprovalRequired,
        'Query.LetterState': requestParameters?.queryLetterState,
        'Query.ProcessState': requestParameters?.queryProcessState,
        'Query.ExportState': requestParameters?.queryExportState,
        'Query.PayrollState': requestParameters?.queryPayrollState,
        'Query.MeritRelevancy': requestParameters?.queryMeritRelevancy,
        'Query.ApprovedByCompanyManager': requestParameters?.queryApprovedByCompanyManager,
        'Query.AllocationWorkflowType': requestParameters?.queryAllocationWorkflowType,
        'Query.ReadyToPayroll': requestParameters?.queryReadyToPayroll,
        'Query.EquityRelevancy': requestParameters?.queryEquityRelevancy,
        'Query.HasOtpIncrease': requestParameters?.queryHasOtpIncrease,
        'Query.IsOtpOnly': requestParameters?.queryIsOtpOnly,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.LocalCurrency': requestParameters?.queryLocalCurrency,
        'Query.ProposalAmount': requestParameters?.queryProposalAmount,
        'Query.ProposalAmountInEuro': requestParameters?.queryProposalAmountInEuro,
        'Query.ProposalDate': requestParameters?.queryProposalDate,
        'Query.ProposalState': requestParameters?.queryProposalState,
        'Query.SpecialPaymentReason': requestParameters?.querySpecialPaymentReason,
        'Query.SpecialPaymentCompensationType': requestParameters?.querySpecialPaymentCompensationType,
        'Query.TemplateLetterName': requestParameters?.queryTemplateLetterName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsSpecialPaymentAdminGetSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsSpecialPaymentAdminGetSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsSpecialPaymentAdminGetSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetSeasonSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsSpecialPaymentAdminGetSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsSpecialPaymentAdminGetSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsSpecialPaymentAdminGetSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminGetSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminGetSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsSpecialPaymentAdminGetSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminGetSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsSpecialPaymentAdminGetSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminGetSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsSpecialPaymentAdminGetSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminGetSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminGetSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSnapshotSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Snapshot>;
  public seasonsSpecialPaymentAdminGetSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSnapshotSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Snapshot>>;
  public seasonsSpecialPaymentAdminGetSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSnapshotSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Snapshot>>;
  public seasonsSpecialPaymentAdminGetSnapshotSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminGetSnapshotSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('seasonsSpecialPaymentAdminGetSnapshotSeasons', { id, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationSnapshotTreeItem>>;
  public seasonsSpecialPaymentAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsSpecialPaymentAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsSpecialPaymentAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminGetTreeOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminGetTreeOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { parentOrgCode: requestParameters?.parentOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsSpecialPaymentAdminPartialUpdateEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshotPartial,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsSpecialPaymentAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        PositionName: requestParameters?.positionName,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        MercerJobCode: requestParameters?.mercerJobCode,
        PositionClass: requestParameters?.positionClass,
        NewPositionClass: requestParameters?.newPositionClass,
        OriginalProposedPositionClass: requestParameters?.originalProposedPositionClass,
        PositionType: requestParameters?.positionType,
        CountryIsoCode: requestParameters?.countryIsoCode,
        IncumbentGid: requestParameters?.incumbentGid,
        IncumbentFirstName: requestParameters?.incumbentFirstName,
        IncumbentLastName: requestParameters?.incumbentLastName,
        IncumbentCountryPlaceOfAction: requestParameters?.incumbentCountryPlaceOfAction,
        ValidationManagerId: requestParameters?.validationManagerId,
        ValidationManagerGid: requestParameters?.validationManagerGid,
        ValidationManagerFirstName: requestParameters?.validationManagerFirstName,
        ValidationManagerLastName: requestParameters?.validationManagerLastName,
        ValidationState: requestParameters?.validationState,
        PlacementState: requestParameters?.placementState,
        NewHireState: requestParameters?.newHireState,
        IsLocked: requestParameters?.isLocked,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        IncumbentAre: requestParameters?.incumbentAre,
        Tag: requestParameters?.tag,
        WasPromoted: requestParameters?.wasPromoted,
        IsTransferred: requestParameters?.isTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsSpecialPaymentAdminPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminQueryCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CandidatePoolModel>>;
  public seasonsSpecialPaymentAdminQueryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminQueryCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CandidatePoolModel>>>;
  public seasonsSpecialPaymentAdminQueryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminQueryCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CandidatePoolModel>>>;
  public seasonsSpecialPaymentAdminQueryCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminQueryCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionEvaluationCandidate>;
  public seasonsSpecialPaymentAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionEvaluationCandidate>>;
  public seasonsSpecialPaymentAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionEvaluationCandidate>>;
  public seasonsSpecialPaymentAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/employee-candidates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeSnapshotsEmployeeSnapshot>;
  public seasonsSpecialPaymentAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/employee-candidates/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        SeasonId: requestParameters?.seasonId,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        CandidatePoolTitle: requestParameters?.candidatePoolTitle,
        OrgCode: requestParameters?.orgCode,
        Gender: requestParameters?.gender,
        OrgLevel: requestParameters?.orgLevel,
        MercerPositionClass: requestParameters?.mercerPositionClass,
        IsPlaced: requestParameters?.isPlaced,
        IsShortlisted: requestParameters?.isShortlisted
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminQueryFieldValuesOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsSpecialPaymentAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsSpecialPaymentAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsSpecialPaymentAdminQueryFieldValuesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('seasonsSpecialPaymentAdminQueryFieldValuesRecords', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/records/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationInformationSnapshot>;
  public seasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationInformationSnapshot>>;
  public seasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationInformationSnapshot>>;
  public seasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminQueryInformationOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritInformationVisibilitySettings>;
  public seasonsSpecialPaymentAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritInformationVisibilitySettings>>;
  public seasonsSpecialPaymentAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritInformationVisibilitySettings>>;
  public seasonsSpecialPaymentAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminQueryInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminQueryInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminQueryMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsSpecialPaymentAdminQueryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminQueryMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsSpecialPaymentAdminQueryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminQueryMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsSpecialPaymentAdminQueryMembers(
    requestParameters?: SeasonsSpecialPaymentAdminQueryMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationSnapshot>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationSnapshot>>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationSnapshot>>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminQueryOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.OrganisationId': requestParameters?.queryOrganisationId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.ParentOrgCode': requestParameters?.queryParentOrgCode,
        'Query.HeadId': requestParameters?.queryHeadId,
        'Query.HeadGid': requestParameters?.queryHeadGid,
        'Query.HeadName': requestParameters?.queryHeadName,
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.AdditionalLineOne': requestParameters?.queryAdditionalLineOne,
        'Query.AdditionalLineTwo': requestParameters?.queryAdditionalLineTwo,
        'Query.AdditionalLineThree': requestParameters?.queryAdditionalLineThree,
        'Query.AdditionalLineFour': requestParameters?.queryAdditionalLineFour,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.OrgType': requestParameters?.queryOrgType,
        'Query.OrgLevelA': requestParameters?.queryOrgLevelA,
        'Query.OrgLevelB': requestParameters?.queryOrgLevelB,
        'Query.OrgLevelC': requestParameters?.queryOrgLevelC,
        'Query.OrgLevelD': requestParameters?.queryOrgLevelD,
        'Query.NumberOfEmployees': requestParameters?.queryNumberOfEmployees,
        'Query.HeadFirstname': requestParameters?.queryHeadFirstname,
        'Query.HeadLastname': requestParameters?.queryHeadLastname,
        'Query.HeadPAOrgCode': requestParameters?.queryHeadPAOrgCode,
        'Query.HeadPlaceOfAction': requestParameters?.queryHeadPlaceOfAction,
        'Query.HeadMercerJobCode': requestParameters?.queryHeadMercerJobCode,
        'Query.HeadMercerPositionClass': requestParameters?.queryHeadMercerPositionClass,
        'Query.HeadManagementGroup': requestParameters?.queryHeadManagementGroup,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.Revenue': requestParameters?.queryRevenue,
        'Query.HeadCount': requestParameters?.queryHeadCount,
        'Query.RevenueOrgSize': requestParameters?.queryRevenueOrgSize,
        'Query.HeadCountOrgSize': requestParameters?.queryHeadCountOrgSize,
        'Query.ShowOrganisationsWithoutOrgInfos': requestParameters?.queryShowOrganisationsWithoutOrgInfos,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSnapshot>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSnapshot>>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSnapshot>>;
  public seasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/snapshots/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        MeritSeasonId: requestParameters?.meritSeasonId,
        Search: requestParameters?.search,
        Directs: requestParameters?.directs,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsSpecialPaymentAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsSpecialPaymentAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsSpecialPaymentAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminQueryParentsOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const seasonId2 = requestParameters?.seasonId2;
    this.checkRequired('seasonsSpecialPaymentAdminQueryParentsOrganisationSnapshots', { seasonId, seasonId2 });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: seasonId2, 'Query.OrgCode': requestParameters?.queryOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlanWithMissingIndividualValues>;
  public seasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlanWithMissingIndividualValues>>;
  public seasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlanWithMissingIndividualValues>>;
  public seasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.KpiId': requestParameters?.queryKpiId,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.RecordStartdate': requestParameters?.queryRecordStartdate,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlan>;
  public seasonsSpecialPaymentAdminQueryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlan>>;
  public seasonsSpecialPaymentAdminQueryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlan>>;
  public seasonsSpecialPaymentAdminQueryPlans(
    requestParameters?: SeasonsSpecialPaymentAdminQueryPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BucketComponentsPossibilities>>;
  public seasonsSpecialPaymentAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BucketComponentsPossibilities>>>;
  public seasonsSpecialPaymentAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BucketComponentsPossibilities>>>;
  public seasonsSpecialPaymentAdminQueryPossibilitiesBudgetBuckets(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/budget-bucket/component-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQuerySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSeason>;
  public seasonsSpecialPaymentAdminQuerySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSeason>>;
  public seasonsSpecialPaymentAdminQuerySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSeason>>;
  public seasonsSpecialPaymentAdminQuerySeasons(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        SeasonType: requestParameters?.seasonType,
        SimulationState: requestParameters?.simulationState,
        'Query.ManagerEndDateAt': requestParameters?.queryManagerEndDateAt,
        'Query.PartnerEndDateAt': requestParameters?.queryPartnerEndDateAt,
        'Query.SeasonType': requestParameters?.querySeasonType,
        'Query.SimulationState': requestParameters?.querySimulationState
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminQuerySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsSpecialPaymentAdminQuerySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsSpecialPaymentAdminQuerySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsSpecialPaymentAdminQuerySimulation(
    requestParameters?: SeasonsSpecialPaymentAdminQuerySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminQuerySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminRecalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public seasonsSpecialPaymentAdminRecalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateCandidatePools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/candidate-pools/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const parentSettingId = requestParameters?.parentSettingId;
    this.checkRequired('seasonsSpecialPaymentAdminRecalculateParentSettingsPopulationSimulationPopulations', {
      simulationId,
      parentSettingId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public seasonsSpecialPaymentAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminRecalculatePlanPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminRecalculateSettingsPopulationSimulationPopulations', {
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminSavePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSavePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public seasonsSpecialPaymentAdminSavePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSavePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsSpecialPaymentAdminSavePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSavePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsSpecialPaymentAdminSavePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSavePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminSavePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminSaveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSaveSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public seasonsSpecialPaymentAdminSaveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSaveSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsSpecialPaymentAdminSaveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSaveSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsSpecialPaymentAdminSaveSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSaveSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminSaveSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminSimulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PopulationCreatedResultPagedDto>;
  public seasonsSpecialPaymentAdminSimulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PopulationCreatedResultPagedDto>>;
  public seasonsSpecialPaymentAdminSimulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PopulationCreatedResultPagedDto>>;
  public seasonsSpecialPaymentAdminSimulatePlanPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminSimulatePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public seasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public seasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public seasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminSimulateRuleInformationVisibilitySettings', {
      settingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeePopulationCreatedResultPagedDto>;
  public seasonsSpecialPaymentAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsSpecialPaymentAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsSpecialPaymentAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsSpecialPaymentAdminSimulateSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminSimulateSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, export: requestParameters?._export },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsSpecialPaymentAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminUnPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsSpecialPaymentAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsSpecialPaymentAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsSpecialPaymentAdminUnPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminUnPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.unPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public seasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public seasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public seasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBenchmarkValuesSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/snapshots/benchmarks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSnapshotBenchmarkValues,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateBucketComponentBatchBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateBucketComponentBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsSpecialPaymentAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBudgetBucket,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsSpecialPaymentAdminUpdateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsSpecialPaymentAdminUpdateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsSpecialPaymentAdminUpdateCandidatePools(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsSpecialPaymentAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsSpecialPaymentAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsSpecialPaymentAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsSpecialPaymentAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsSpecialPaymentAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateInformationVisibilitySettings', { settingsId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateManyBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsSpecialPaymentAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateManyBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateManyBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsSpecialPaymentAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateManyBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/budget-bucket/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBudgetBuckets,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsSpecialPaymentAdminUpdateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsSpecialPaymentAdminUpdateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsSpecialPaymentAdminUpdateMembers(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateOrganisationInformationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsSpecialPaymentAdminUpdatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdatePlanSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdatePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsSpecialPaymentAdminUpdatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsSpecialPaymentAdminUpdatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsSpecialPaymentAdminUpdatePlans(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsSpecialPaymentAdminUpdatePlans', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdatePublicationSettingsPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsSpecialPaymentAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsSpecialPaymentAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsSpecialPaymentAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCommunicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsSpecialPaymentAdminUpdateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsSpecialPaymentAdminUpdateSeasonSettings(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setSeasonSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsSpecialPaymentAdminUpdateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsSpecialPaymentAdminUpdateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsSpecialPaymentAdminUpdateSeasons(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonsSimulationsSimulation>;
  public seasonsSpecialPaymentAdminUpdateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonsSimulationsSimulation>>;
  public seasonsSpecialPaymentAdminUpdateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonsSimulationsSimulation>>;
  public seasonsSpecialPaymentAdminUpdateSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsUpdateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsSpecialPaymentAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationMembersSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsSpecialPaymentAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationMembersSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsSpecialPaymentAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationMembersSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsSpecialPaymentAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsSpecialPaymentAdminUpdateSimulationMembersSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsSpecialPaymentAdminUpdateSimulationMembersSimulation', { seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSimulationMembers,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: UpdateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SpecialPaymentGlobalHrbpApproverRule>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: UpdateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SpecialPaymentGlobalHrbpApproverRule>>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: UpdateSpecialPaymentGlobalHrbpApproverRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SpecialPaymentGlobalHrbpApproverRule>>;
  public updateSpecialPaymentGlobalHrbpApproverRules(
    requestParameters?: UpdateSpecialPaymentGlobalHrbpApproverRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('updateSpecialPaymentGlobalHrbpApproverRules', { seasonId, id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/special-payment/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/global-hrbp-rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSpecialPaymentGlobalHrbpApproverRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
